export default __webpack_public_path__ + "static/media/RETAIL_CONNECT_ONE_TO_ONE_EMEA.8b6ca765.png";